import axios from 'axios'
import Cookie from 'js-cookie'

import apiAuth from './methods/auth'
import apiTours from './methods/tours'

export default {
  internetError: false,

  removeJWT () {
    Cookie.remove('access_token')
    Cookie.remove('refresh_token')
  },

  resetJWT (data) {
    Cookie.set('access_token', data.access_token)
    Cookie.set('refresh_token', data.refresh_token)
  },

  clean (obj) {
    for (const propName in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (!obj.hasOwnProperty(propName)) continue
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName]
      }
    }
  },

  // eslint-disable-next-line no-unused-vars
  setupInstance (store, router) {
    this.apiInstance = axios.create({
      baseURL: process.env.VUE_APP_API_BASE_URL,
      headers: {
        common: {
          Access: 'application/json',
          'Accept-Language': 'ru',
          'X-Requested-With': 'XMLHttpRequest'
        }
      },
      mode: 'cors'
    })

    this.apiInstance.interceptors.request.use(async config => {
      if (Cookie.get('access_token')) {
        config.headers.common['Access-Token'] = `${Cookie.get('access_token')}`
      }
      return config
    }, async error => {
      return Promise.reject(error)
    })

    this.apiInstance.interceptors.response.use(async response => {
      this.internetError = false
      return response
    }, async (error) => {
      if (!error.response) {
        if (!this.internetError) {
          this.internetError = true
          console.error('Error: internet connection')
        }
      } else { this.internetError = false }

      let code = 0
      if (error.response) { code = error.response.status }

      if (code === 401) {
        const errorUrl = error.response.config.url
        store.dispatch('auth/SIGNOUT')
        if (errorUrl !== 'auth/login' && errorUrl !== 'auth/verify') {
          router.push({ name: 'auth.signin' }).catch(() => {})
        }
      }

      return Promise.reject(error)
    })
  },

  install (Vue, store, router) {
    this.app = Vue.prototype
    this.setupInstance(store, router)

    const repositories = {
      auth: apiAuth(this.apiInstance),
      tours: apiTours(this.apiInstance)
    }

    Vue.prototype.cleanObject = this.clean
    Vue.prototype.$api = repositories
    Vue.prototype.$apiInstance = this.apiInstance
    store.$api = repositories
    store.resetJWT = this.resetJWT
    store.removeJWT = this.removeJWT
  }
}
